import React from "react";
import { ArticleChangeImportance } from "../../../../../amorg-common";
import { colors, rawColors } from "../../../../../designSystem/colors/color";
import { Flex } from "../../../../../designSystem/compositeComponents/FlexHelpers";
import { RadioButtonButtonList } from "../../../../../designSystem/inputs/RadioButtonButton";
import { Toggletip } from "../../../../../designSystem/Toggletip";

type ArticleViewImportanceSelectorProps = {
    importance: ArticleChangeImportance,
    groupName: string;
    disabled?: boolean,
    onImportanceChange: (importance: ArticleChangeImportance) => void;
};
export function ArticleViewImportanceSelector (props: ArticleViewImportanceSelectorProps): JSX.Element
{

    function handleChange (selectedValue: string)
    {
        props.onImportanceChange(selectedValue as ArticleChangeImportance);
    }

    return (
        <Flex gap={8}>
            <div style={{ flexGrow: 1 }}>
                <RadioButtonButtonList
                    groupName={props.groupName}
                    disabled={props.disabled}
                    options={[
                        {
                            text: 'grøn', value: 'low',
                            selectedColorProfile: {
                                backgroundSelected: rawColors.green.normal,
                                text: colors.text.white,
                                textHover: colors.text.white

                            }
                        },
                        {
                            text: 'gul', value: 'medium',
                            selectedColorProfile: {
                                backgroundSelected: rawColors.yellow.normal,
                                text: colors.text.white,
                                textHover: colors.text.white

                            }
                        },
                        {
                            text: 'rød', value: 'high',
                            selectedColorProfile: {
                                backgroundSelected: rawColors.red.normal,
                                text: colors.text.white,
                                textHover: colors.text.white

                            }
                        }
                    ]}
                    selectedValue={props.importance}
                    onChange={handleChange}
                />
            </div>

            <Toggletip>
                <>
                    <div><b>Grøn</b></div>
                    <div>Ændringer der vurderes til ikke at have betydning</div>
                    <div><b>Gul</b></div>
                    <div>Ændringer der kan have betydning</div>
                    <div><b>Rød</b></div>
                    <div>Ændringer der har betydning</div>
                </>
            </Toggletip>
        </Flex>
    );
}